gsap.registerPlugin(ScrollTrigger);

// ======================================= SECTION 1
gsap.set('.co-home-s1--logo img', {
  y: 30,
  scale: 1,
  opacity: 0,
  transition: 0
});
// gsap.set('.co-home-s1-sub-logo', { y: 30, scale: 1.05, transition: 0 });

gsap.to('.co-home-s1--logo img', {
  y: 0,
  opacity: 1,
  scale: 1,
  duration: 0.75,
  opacity: 1,
  ease: "Power4.inOut",
  delay: 0.1,
});
// gsap.to('.co-home-s1-sub-logo', { y: 0, opacity: 1, scale: 1, duration: 0.75, ease: "Power4.inOut" });

// header logo anim
const headerLogo = document.querySelector('.logo-home'); // adjust selector
const hero = document.querySelector('.co-home-s1');    // adjust selector

if (headerLogo && hero) {
  const heroHeight = hero.offsetHeight;

  function checkScroll() {
    if (window.scrollY > heroHeight) {
      headerLogo.classList.add('scrolled');
    } else {
      headerLogo.classList.remove('scrolled');
    }
  }

  // Run on scroll
  window.addEventListener('scroll', checkScroll);

  // Run on load (in case page is reloaded mid-scroll)
  window.addEventListener('load', checkScroll);
}

// header logo anim end


//sec 3

const swiper = new Swiper('.co-home-s3--slider', {
  // Default parameters
  slidesPerView: 4,
  spaceBetween: 24,
  loop: true,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.7,
      spaceBetween: 12
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 24
    },
    // when window width is >= 640px
    769: {
      slidesPerView: 4,
      spaceBetween: 24
    }
  }
})

//sec 3 end